<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <Nav />
      <div class="eol-main-container">
        <div class="expand-content" ref="137">
          <div class="content-header">
            <div class="text">发扬劳动三精神 · 谱写一流新篇章</div>
          </div>
          <div class="content-box">
            <div class="expand-bg">
              <div class="expand-content">
                <div class="swiper-content" v-if="expandData && expandData.length > 0">
                  <swiper :options="expandSwiperOption">
                    <swiper-slide :style="`background-image: url('${item.photo}');`" v-for="item in expandData.slice(0,-3)" :key="item.id" :data-kcid="item.id" :data-kcName="item.name">
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination expand"></div>
                  <div class="swiper-button-next expand" v-text="'>'"></div>
                  <div class="swiper-button-prev expand" v-text="'<'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-box expand">
          <div class="cover-item" v-for="item,index in expandData.slice(-3)" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
        </div>

        <div class="secure-content secure" ref="139">
          <div class="content-header">
            <div class="text">弘扬职业精神 · 恪守职业道德</div>
          </div>
          <div class="content-box">
            <div class="cover-item" v-for="item,index in secureData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"


export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/profession.png"),
      school_code: localStorage.getItem("schoolCode"),
      expandSwiperOption: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 70,
          stretch: 200,
          depth: 480,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.expand`,
          prevEl: `.swiper-button-prev.expand`,
        },
        pagination: {
          el: `.swiper-pagination.expand`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-kcid");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=profession`, "_blank")
            }

          },
        },
      },
      expandData: [], // 弘扬劳动三精神
      secureData: [], // 筑牢职业操守
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
  },
  methods: {
    async getListData () {
      // 弘扬劳动三精神
      await services.getCourseList({ page: 1, size: 100, category_id: "137", school_code: this.school_code }).then(res => {
        this.expandData = res.data.items
      })

      // 筑牢职业操守
      await services.getCourseList({ page: 1, size: 3, category_id: "139", school_code: this.school_code }).then(res => {
        this.secureData = res.data.items
      })
      await this.jumpPosition()
    },
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=profession`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  padding: 64px 0 0;
  position: relative;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 135px;
    width: 1920px;
    height: 788px;
    background: url('../../../assets/hzvtc/list/profession-bg-c.png') no-repeat
      center/cover;
  }
  .content-header {
    width: 100%;
    height: 42px;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 172px;
      height: 26px;
      position: absolute;
      top: 50%;
      background: url('../../../assets/hzvtc/common/list-ttile.png') no-repeat 0 /
        cover;
      transform: translateY(-40%);
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
    .text {
      font-size: 42px;
      font-weight: bold;
      background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .content-box {
    position: relative;
    z-index: 1;
  }
  .expand-content {
    .content-header {
      &::before,
      &::after {
        width: 215px;
      }
    }
    .content-box {
      .swiper-slide {
        width: 740px !important;
        height: 416px !important;
        .cover {
          width: 100%;
          height: 100%;
        }
      }

      ::v-deep .swiper-pagination {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -32px;
        left: 50%;
        transform: translateX(-50%);
      }
      ::v-deep .swiper-pagination-bullet {
        width: 7px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        opacity: 0.5;
        border-radius: 50%;
        display: block;
        transition: all 0.3s;
        margin-right: 4px;
      }

      ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 13px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        border-radius: 3px;
        opacity: 1;
        margin-right: 7px;
      }
    }
  }
}
.secure-content {
  position: relative;
  &::before {
    content: '';
    display: inline-block;
    width: 1920px;
    height: 368px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -40px;
    background: url('../../../assets/hzvtc/list/profession-bg-f.png') no-repeat
      0 / cover;
  }
}
.expand-bg {
  background-position: center;
  background-size: cover;
  padding: 48px 0 38px;
  .expand-content {
    width: 1200px;
    margin: 0 auto;
    .swiper-content {
      position: relative;
      width: 100%;
      height: 465px;
      display: flex;
      align-items: center;
      .swiper-container {
        height: 100%;
        .swiper-wrapper {
          .swiper-slide {
            width: 740px;
            height: 416px;
            background: #fff;
            background-size: 100% auto;
            background-position: center;
            cursor: pointer;
            &.swiper-slide-active {
              -webkit-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -moz-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -o-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -ms-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              transform: translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) !important;
              border: 2px solid red;
            }
          }
        }
      }
      /deep/ .swiper-pagination {
        bottom: 10px;
        width: 100%;
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #cdb29f;
          border-radius: 50%;
          margin: 0 6px;
        }
        .swiper-pagination-bullet.swiper-pagination-bullet-active {
          width: 10px;
          height: 10px;
          background: #dd3639;
          border-radius: 50%;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        flex-shrink: 0;
        background-size: cover;
        background: #000;
        z-index: 100;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        text-align: center;
        line-height: 44px;
        width: 42px;
        height: 44px;
        color: #ffffff;
        font-size: 22px;
        font-family: fangsong;
        font-weight: bold;
      }
      .swiper-button-prev {
        left: 200px;

        background: rgba(0, 0, 0, 0.37);
        border-radius: 22px 0px 0px 22px;
      }
      .swiper-button-next {
        right: 200px;

        background: rgba(0, 0, 0, 0.37);
        border-radius: 0px 22px 22px 0px;
      }
    }
  }
}
.content-box {
  &.expand {
    padding-bottom: 26px;
  }

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .cover-item {
    cursor: pointer;
    width: 380px;
    height: 214px;
    margin-bottom: 20px;
  }
  .flex-hide {
    flex: 0 0 380px;
    visibility: hidden;
    display: block;
  }
}
.secure {
  .content-header {
    margin: 46px 0 60px;
    &::before,
    &::after {
      width: 270px;
    }
  }
}
</style>